import { appActions as actions } from "./actions";

export const INIT_STATE = {
  country: "",
  data: {},
  emailSettingsRes: {},
  error: "",
  loading: false,
  locale: {},
  res: {},
};

export const appReducer = (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case actions.COUNTRY_REFRESH: {
      return {
        ...state,
        country: action.payload,
      };
    }
    case actions.GET_CURRENT_LOCALE:
    case actions.GET_SPECIFIC_LOCALE:
    case actions.SEND_ERROR_REPORT: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case actions.SEND_REVIEW_REQUEST_EMAIL_SETTINGS: {
      return {
        ...state,
        loading: true,
      };
    }
    case actions.GET_CURRENT_LOCALE_SUCCESS:
    case actions.GET_SPECIFIC_LOCALE_SUCCESS: {
      return {
        ...state,
        locale: action.payload,
      };
    }
    case actions.SEND_ERROR_REPORT_SUCCESS: {
      return {
        ...state,
        res: action.payload,
      };
    }
    case actions.SEND_REVIEW_REQUEST_EMAIL_SETTINGS_SUCCESS: {
      return {
        ...state,
        loading: false,
        emailSettingsRes: action.payload,
      };
    }
    case actions.GET_CURRENT_LOCALE_ERROR:
    case actions.GET_SPECIFIC_LOCALE_ERROR:
    case actions.SEND_ERROR_REPORT_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case actions.SEND_REVIEW_REQUEST_EMAIL_SETTINGS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    default:
      return state;
  }
};
